import { useContext } from 'react';

import { type ResolvedContextData } from '@common/defaults/ContextData';

import { NextContext } from './NextContext';

export const useContextData = (): Readonly<ResolvedContextData> => {
    const contextData = useContext(NextContext);
    return contextData;
};
